import { type MutationError, trpc } from '@/shared/api';

interface UseAddRecommendedProductOptions {
  readonly onSuccess?: () => void;
}

/** 공개 상품을 추천 목록 맨 뒤에 넣는다. 8개가 차 있거나 비공개면 서버가 거부한다. */
export const useAddRecommendedProduct = ({ onSuccess }: UseAddRecommendedProductOptions = {}) => {
  const mutation = trpc.productManagement.recommendations.add.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    addProduct: (productId: string) => mutation.mutate({ productId }),
    isPending: mutation.isPending,
    error,
    /** 모달을 열고 닫을 때 지난 서버 거부 문구를 지운다 — 새 모달에 옛 오류가 남지 않게. */
    reset: () => mutation.reset(),
  };
};
